// adapters/mnh.adapter.js

export const adaptMnhInvoice = (raw) => {
  const firmInfo = raw.firmInfo || {};
  const customer = raw.customerDetail || {};
  const billingItems = Array.isArray(raw.billingItem) ? raw.billingItem : [];
  const summary = raw.billSummary || {};

  /* -------------------------------------------------
     Adapter output (STANDARD DTO)
  ------------------------------------------------- */
  return {
    /* -------------------------------------------------
       Report
    ------------------------------------------------- */
    reportName: raw.reportName || "",

    /* -------------------------------------------------
       Firm
    ------------------------------------------------- */
    firmInfo: {
      name: firmInfo.FIRM_NAME || "",
      address: firmInfo.FIRM_ADDRESS || "",
      city: firmInfo.FIRM_CITY || "",
      pincode: firmInfo.FIRM_PINCODE || "",
      phone: firmInfo.FIRM_PHONE || firmInfo.FIRM_MOBILE || "",
      email: firmInfo.FIRM_EMAIL || "",
      tin: firmInfo.FIRM_TIN || "",
      cin: firmInfo.FIRM_CIN || "",
      stateCode: firmInfo.FIRM_STATECODE || "",
      locationName: firmInfo.FIRM_LOCATIONNAME || "",
    },

    /* 🔹 Customer */
    customerDetail: {
      patientName: customer.patientName || "",
      age: customer.age || "",
      address: customer.address || "",
      patientType: customer.patientType || "",
      billNumber: customer.billNumber || "",
      billDate: customer.billDate || "",
      section: customer.section || "",
      regNumber: customer.regNumber || "",
      doa: customer.doa || "",
      dod: customer.dod || "",
      roomName: customer.roomName || "",
      doctorName: customer.doctorName || "",
      dep: customer.dep || "",
      insPlan: customer.insPlan || "",
      ipNumber: customer.ipNumber || "",
    },

    /* 🔹 BILLING ITEMS (THIS IS THE IMPORTANT PART) */
    billingItems: (billingItems || []).map((s, i) => ({
      slNo: s.slNo || i + 1,
      serviceName: s.serviceName || "",
      charges: s.charges ?? null,
      units: s.units ?? null,
      taxRate: s.taxRate ? s.taxRate * 100 : null,
      gross: s.gross ?? null,
      discount: s.discount ?? null,
      netAmount: s.netAmount ?? 0,

      /* 🔥 REQUIRED FOR MNH CONSOLIDATED ROWS */
      isConsolidated: Boolean(s.isConsolidated),
    })),

    /* 🔹 Summary */
    billSummary: {
      total: summary.total ?? 0,
      discount: summary.discount ?? 0,
      billAmount: summary.billAmount ?? 0,
      receivedAmount:
        Number(summary.receivedAmount ?? 0) +
        Number(summary.advancePayment ?? 0),
      payable: summary.paymentAmount ?? 0,
      roundOff: summary.roundOff ?? 0,
      billAmountInWords: summary.billAmountInWords || "",
      generatedBy: summary.generatedBy || "",
      tax: summary.tax ?? 0,
    },
  };
};
